module.exports = __webpack_public_path__ + "img/scene3@2x.14e389fa.png";